import React, { useState, useRef, useEffect } from "react";
import dropdown from "./dropdown.svg";

const AutocompleteDropdown = (props) => {

  const {options,
        placeholder = "Search...",
        onSelect,optionWindowStyle ,
        style,
        optionWindowHeight="6rem",
        selectedOption } = props;
           
  const [inputValue, setInputValue] = useState(selectedOption);
  const [filteredOptions, setFilteredOptions] = useState(options);
  const [showDropdown, setShowDropdown] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    // Close dropdown on outside click
    const handleOutsideClick = (event) => {
        
      if (inputRef.current && !inputRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, []);

  useEffect(()=>{
    const element = document.getElementById("selected")

    if(element)
    element.scrollIntoView({behavior: "instant", block: "end"})

  },[ showDropdown])

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);
    setFilteredOptions(
      options.filter((option) =>
        option.label.toLowerCase().includes(value.toLowerCase())
      )
    );
    // setShowDropdown(true);
  };

  const selectOption = (option) => {
    setInputValue(option.label);
    setShowDropdown(false);
    onSelect(option.value);

  };

  const DropdownStyle = {
    width: "100%",
    padding: "8px",
    // marginBottom: "10px",
    borderRadius: "5px",
    border: "1px solid #ccc",
    boxSizing: "border-box",
    color: "#808080",
    backgroundColor: "#F6F6F6",
  };

  const handleFocus = ()=>{
    setShowDropdown(true)
    setFilteredOptions(options)
  }

  const dropIconStyle= {
    position: "absolute",
    top: "45%",
    right: "0.5rem",
    zIndex: 1000,
    // backgroundColor:"#F6F6F6",
    // padding:"0.5rem 0.5rem",
  }

  return (
    <div style={{position:"relative"}}>
        <span style={dropIconStyle}>
        <img src={dropdown} alt="dropdown" style={{width: "0.7rem", height: "auto"}}/>
        </span>
      <input
        type="text"
        ref={inputRef}
        value={inputValue}
        onChange={handleInputChange}
        placeholder={placeholder}
        onFocus={handleFocus}
        style={ style?style:DropdownStyle }
      />
      {showDropdown && (
        <ul
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            right: 0,
            background: "white",
            border: "1px solid #ccc",
            maxHeight: optionWindowHeight,
            overflowY: "auto",
            margin: 0,
            padding: 0,
            listStyle: "none",
            zIndex: 1000,
            ...optionWindowStyle
          }}
        >
          { filteredOptions.length<1?
            <li
            style={{
                padding: "8px",
                cursor: "pointer",
            }}
            >
              No Records found
            </li>
          : filteredOptions.map((option, index) => (
            <li
              key={option.value+index}
              onMouseDown={() => selectOption(option)}
              id={option.label === inputValue ? "selected" : undefined} 
              style={{
                padding: "8px",
                background: option.label === inputValue ? "#1742F5" : "white",
                color: option.label === inputValue ? "white" : "black",
                cursor: "pointer",
              }}
              onMouseEnter={(e) => (e.target.style.backgroundColor = "lightgray")}
              onMouseLeave={(e) => (e.target.style.backgroundColor = option.label === inputValue ? "blue" : "white")}
              >
              {option.label}
            </li>
          ))
        
        }
        </ul>
      )}
    </div>
  );
};

export default AutocompleteDropdown;
